export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-bone grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-baseline gap-2 mb-6">
              <span className="font-serif italic text-3xl md:text-4xl">Sua Piscina</span>
              <span className="overline text-bone/60">PT</span>
            </div>
            <p className="text-base md:text-lg text-bone/70 font-light max-w-md leading-relaxed">
              Estúdio de visualização residencial. Ajudamos proprietários em Cascais, Oeiras, Sintra e Lisboa a visualizar possibilidades reais para o jardim antes de pedir orçamentos ou avançar com uma obra.
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="overline text-bone/60 mb-5">Zonas</div>
            <ul className="space-y-3 text-bone/80 font-light">
              <li>Cascais</li>
              <li>Oeiras</li>
              <li>Sintra</li>
              <li>Lisboa</li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="overline text-bone/60 mb-5">Contacto</div>
            <ul className="space-y-3 text-bone/80 font-light">
              <li>hello@suapiscinapt.com</li>
              <li>suapiscinapt.com</li>
              <li className="text-bone/50">WhatsApp brevemente</li>
            </ul>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-bone/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="overline text-bone/50">
            2026 Sua Piscina PT. Todos os direitos reservados.
          </div>
          <div className="overline text-bone/50 flex flex-wrap items-center gap-x-6 gap-y-2">
            <a href="/politica-de-privacidade" className="editorial-link hover:text-bone" data-testid="footer-privacy-link">Política de Privacidade</a>
            <a href="/termos" className="editorial-link hover:text-bone" data-testid="footer-terms-link">Termos</a>
            <a href="/rgpd" className="editorial-link hover:text-bone" data-testid="footer-rgpd-link">RGPD</a>
            <a href="/admin" className="editorial-link hover:text-bone" data-testid="footer-admin-link">Acesso interno</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
